<template>
    <div class="col-12 bg-secondary pb-2 mb-2 py-2 d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
            <p class="mb-0 p-1">
                <template>
                    {{ index + 1 }}.
                    <span v-if="butaca.sectorName">
                        {{ butaca.sectorName }} -
                    </span>
                    <span v-else-if="butaca.nombreSector">
                        Sector: {{ butaca.nombreSector }} -
                    </span>
                </template>
  
                <template v-if="!regionSeleccionada">
                    <span v-if="butaca.fila">
                        Fila: {{ butaca.fila }} - Butaca: {{ butaca.butaca }}
                    </span>
                </template>
          
                <template v-if="butaca.numero">
                    Plaza: {{ butaca.numero }}
                </template>
            </p>
        </div>
  
        <button @click="handleDelete" 
                :disabled="disabled" 
                class="btn btn-sm btn-transparent-danger"
        >
            <i class="fa fa-times"></i>
        </button>
    </div>
</template>
  
<script>
    export default {
        props: {
            index: {
                type: Number,
                required: true
            },
            butaca: {
                type: [Object],
                default: null
            },
            regionSeleccionada: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean
            }
        },   
        methods: {
            handleDelete() {
                this.$emit('borrar-plaza', this.butaca);
            }
        }
    };
</script>
  
<style scoped>
.btn-transparent-danger {
  background-color: transparent !important ; 
  border: none; 
}

.btn-transparent-danger:hover {
  color: #fff !important;
  background-color: #dc3545 !important;
  border-color: #dc3545;
  box-shadow: none;
}
</style>
  